import { BaseModelActive, BaseModel } from '../../../shared/base/base.models';
import { PointOfSale } from '../../../inside-layout/routes/points-of-sale/points-of-sale.models';
import { DistributionCalendar } from '../distribution-calendars/distribution-calendars.models';
import { GiftPackage } from '../gift-package/gift-package.models';
import { PaymentMethod } from '../payment-methods/payment-methods-models';
import { Municipality } from '../municipalities/municipalities.models';
import { MeanOfDelivery } from '../means-of-delivery/means-of-delivery.models';
import { CostPolicy } from '../cost-policies/cost-policies.models';
import { Product } from '../products/products.models';
import { ProductCatalogue } from '../product-catalogues/product-catalogues.models';
import { RebatePolicy } from '../rebate-policies/rebate-policies.models';
import { User } from '../users/users.models';
import { OfferedProduct } from '../offered-products/offered-products.models';
import { parseNumber } from 'devextreme/localization';

export class CustomerOrder extends BaseModel {
    buyer?: User | string;
    status?: CustomerOrderStatus;
    lastChange?: string; //TODO ovo dodati ?
    costs?: CustomerOrderCost[] | string[];
    customerOrderGiftPackageProducts?: CustomerOrderGiftPackageProduct[] | string[];
    customerOrderProducts?: CustomerOrderProduct[] | string[];
    rebatePolicies?: CustomerOrderRebatePolicy[] | string[];
    date?: string;
    distributionCalendar?: DistributionCalendar | string;
    documentNumber?: string;
    expectedShipmentDate?: string;
    expectedShipmentTimeFrom?: string;
    expectedShipmentTimeTo?: string;
    expensesValue?: number;
    giftPackage?: GiftPackage | string;
    goodsValue?: number;
    internalNote?: string;
    invoiceValue?: number;
    meansOfDelivery? : MeanOfDelivery | string;
    note?: string;
    paymentMethod?: PaymentMethod | string;;
    pointOfSale?: PointOfSale | string;
    rebateValue?: number;
    receivedPromotionalCode?: string;
    regularValue?: number;
    saleValue?: number;
    totalValue?: number;
    shippingAddress?: string;
    shippingFullName?: string;
    shippingMunicipality?: Municipality | string;
    shippingPhoneNumber?: string;
    shippingZipCode?: string;
    usedPromotionalCode?: string;
    userId?: string; 
    customerOrderGiftPackage?: GiftPackage | string;
    upcPayments: UpcPayment[];
    payed: boolean; // only for displaying online payments
    opaPayments: OPAPayment[];

    //helper
    companyName?: string;
}
export class OPAPayment {
    paymentStatus?: OPAPaymentStatus;
    opaId?: number;
    accountNumber?: string;
    message?: string;
    amount?: number;
    status?: number;
    dateTime?: Date; 
    qrCode?: string;
    paymentOrderId?: number;
    refunded?: Boolean;
}

export enum OPAPaymentStatus {
    ACCEPTED = 'ACCEPTED', DECLINED = 'DECLINED', IN_PROGRESS = 'IN_PROGRESS'
}

export enum CustomerOrderStatus {   
    SUBMITTED, 
    APPROVED, 
    CANCELED,
    PARTIALY_DELIVERED, 
    DELIVERED,
    PRE_SUBMITTED
}

export enum CustomerOrderStatusView {
    APPROVED, 
    CANCELED,
    SUBMITTED
}
export class CustomerOrderCostPolicy extends BaseModel {
    costPolicy?: CostPolicy;
    userId?: string;
}

export class UpcPayment {
    ApprovalCode: number;
    Currency: number;
    Email: string;
    OrderID: number;
    ProxyPan: string;
    PurchaseDesc: string;
    PurchaseTime: string;
    SD: string;
    TotalAmount: number;
    TranCode: number;
    XID: string;
}

export class CustomerOrderGiftPackageProduct extends BaseModel {
    product?: Product | string;
    userId?: string;
}

export class CustomerOrderProduct extends BaseModel {
    approvedQuantity?: number;
    deliveredQuantity?: number;
    discountPercentage?: number;
    orderedQuantity?: number;
    offeredProduct?: OfferedProduct | string;
    product?: string; // samo za out 
    productCatalogue?: ProductCatalogue | string;
    rebatePercentage?: number;
    userId?: string;

    invoicePrice?: number;
    
    regularPrice?: number;
    salePrice?: number;

    //helper
    lookup?: string;

    constructor(offeredProduct: OfferedProduct) {
        super();
        this.offeredProduct = offeredProduct;
        this.regularPrice = offeredProduct.regularPrice;
        this.salePrice = offeredProduct.salePrice != null ? offeredProduct.salePrice : offeredProduct.regularPrice;
        this.orderedQuantity = 0;
        this.discountPercentage = offeredProduct.discountPercentage;
        this.approvedQuantity = 1;
        this.rebatePercentage = 0;
        this.invoicePrice = this.salePrice - this.salePrice * this.rebatePercentage/100;
    }
}

export class CustomerOrderRebatePolicy extends BaseModel {
    rebatePolicy?: RebatePolicy;
    userId?: string;
}

export class CustomerOrderCost extends BaseModel {
    costPolicy?: CostPolicy | string;
    value?: number;
}